export const SELECT_OPTION_LIST_EXPANDED_STATUS = {
    OPEN: 'open',
    HIDE: 'hide',
};
